import React from "react";
import styles from "./TravelHomeSection.module.css"
import travel1 from "../../../Images/travelhomepage_img1.png"
import travel2 from "../../../Images/travelhomepage_img.png"

const TravelHomeSection = () => {
    return (
        <section className={styles.hero}>

            <div className={styles.content}>

                <h2> Blog and updates page Revolutionize Travel & <br />
                    Hospitality with AI <br />
                    Automation</h2>
                <p>
                    Deliver seamless bookings, personalized guest <br />
                    experiences, and 24/7 support with intelligent AI <br />
                    agents</p>

                <div className={styles.buttons}>
                    <button className={styles.primaryBtn}>Request a Demo</button>
                </div>
            </div>

            <div className={styles.heroImage}>
                <img
                    src={travel1}
                    alt="hero illustration"
                    className={styles.travelimg}
                />
                <img
                    src={travel2}
                    alt="hero illustration"
                    className={styles.travelimg1}

                />
            </div>
        </section>
    );
};

export default TravelHomeSection


